import React, { useEffect } from 'react';
import { useTypedSelector } from 'lib/centralStore';
import { selectRedirectConfig } from 'features/configuration/selectors';
import { useRouter } from 'next/router';
import { SessionState, useInternalSession } from 'hooks/useInternalSession';
import { isMatch, isNotEmpty } from 'utility/functions';
import { AppFragment } from 'enums/path-fragment';
import useWindowSize from 'hooks/useWindowSize';

const ALLOWED_VERTICALS: Array<string> = [
  AppFragment.Live,
  AppFragment.Sport,
  AppFragment.Ippica,
  AppFragment.Virtuali,
];

const useRedirectAppSport = () => {
  const { asPath } = useRouter();

  // TODO : should be useragent related, not windows size
  const { isMobile } = useWindowSize();

  // distinguish redirect by path instead of globally
  const flags = useTypedSelector(selectRedirectConfig);

  const {
    status,
    session: { user },
  } = useInternalSession();

  const { token, cardNumber } = user ?? {};

  useEffect(() => {
    if (!isMatch(process.env.NEXT_PUBLIC_MOBILE_REDIRECT_URL, '^http')) return;
    if (!isMobile) return;
    if (status === SessionState.loading) return;
    if (status === SessionState.authenticated && (!token || !cardNumber)) return;

    const [_r, verticale, disciplina] = asPath.toLowerCase().split('/');
    if (!ALLOWED_VERTICALS.includes(verticale)) return;

    // redirect is applied only to vertical root pages (/sport , /live, /ippica, /virtuali)
    if (isNotEmpty(disciplina)) return;

    if (!flags[verticale]) return;

    const params = new URLSearchParams();
    if (token) params.set('token', token);
    if (cardNumber) params.set('carta', cardNumber);

    params.set('redirect', verticale === AppFragment.Virtuali ? 'virtual' : verticale);

    const url = `${process.env.NEXT_PUBLIC_MOBILE_REDIRECT_URL}?${params.toString()}`;

    document.location.replace(url);

  }, [token, cardNumber, asPath, isMobile, status]);
};

export const RedirectAppSport = () => {
  useRedirectAppSport();
  return <React.Fragment key={'app-sport-redirect'} />;
};
